<template>
<v-dialog v-model="popup.show" max-width="500px" transition="slide-y-reverse-transition" persistent scrollable>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar class="pl-2" color="transparent" flat>
        <v-spacer></v-spacer>
        <v-toolbar-title class="headline ml-4">{{popup.type}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          @click.native="popup.show = false"
          icon
          flat
        ><v-icon>close</v-icon></v-btn>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-layout row wrap>
        <v-flex v-if="popup.type == 'Resetting'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">You will lose all unsaved changes</div>
          <div class="subheading pb-3">Are you sure?</div>
          <div>
            <v-btn @click.native="broadcast('reset')" color="error" depressed>Reset</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Creating Task' || popup.type == 'Updating Task'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">
            {{popup.type == 'Creating Task' ? 'Creating' : 'Updating'}} a <b>{{taskD.type}}</b> task named <b>{{taskD.name}}</b>
          </div>
          <div v-if="taskD.type == 'Linking'" class="subheading pb-3">
            <span>Linked With</span><br><b>{{linkedTaskPath()}}</b>
          </div>
          <div v-if="taskD.type == 'Practice'">
            <div class="subheading pb-3">
              <b>{{taskD.numOfQuestions}} total questions</b> with <b>{{numQuestions(true) + ' easy questions'}}</b>
            </div>
            <div v-if="taskD.percentEasy">
              <div class="subheading pb-3">Possible Easy Questions:
                <span :class="possibleQuestions(true) < numQuestions(true) ? 'error--text' : 'success--text'">
                  <b>{{possibleQuestions(true) + ' questions'}}</b>
                </span>
              </div>
              <div class="subheading pb-3">Possible Hard Questions:
                <span :class="possibleQuestions(false) < numQuestions(false) ? 'error--text' : 'success--text'">
                  <b>{{possibleQuestions(false) + ' questions'}}</b>
                </span>
              </div>
            </div>
            <div v-else>
              <div class="subheading pb-3">Possible Questions:
                <span :class="possibleQuestions() < taskD.numOfQuestions ? 'error--text' : 'success--text'">
                  <b>{{possibleQuestions() + ' questions'}}</b>
                </span>
              </div>
            </div>
          </div>
          <div v-else-if="taskD.type == 'NCLEX'">
            <div class="subheading pb-2"><b>{{taskD.minQuestions}}</b> to <b>{{taskD.maxQuestions}}</b> questions per area on test</div>
            <div v-if="enough" class="subheading pb-2 success--text"><b>All areas have enough questions</b></div>
            <div v-else class="subheading">
              <div class="pb-2"><b>Not enough questions in some areas</b></div>
              <div v-for="area in areas" class="pb-2">
                <span>{{area}}</span>: <span :class="totals[area] < taskD.maxQuestions ? 'error--text' : 'success--text'">{{totals[area]}}</span>
              </div>
            </div>
          </div>
          <div v-if="taskD.type == 'Practice' || taskD.type === 'NCLEX'">
            <div class="subheading pb-2">
              <span><b>{{taskD.timeAllowed ? taskD.timeAllowed + ' mins' : 'Unlimited'}}</b> time allowed and </span>
              <span><b>{{taskD.attempts ? taskD.attempts : 'Unlimited'}}</b> attempts</span>
            </div>
          </div>
          <div class="subheading pb-3">Continue?</div>
          <div v-if="taskD.type == 'Practice' || taskD.type == 'NCLEX'">
            <v-btn
              @click.native="broadcast(popup.type == 'Creating Task' ? 'createTask' : 'updateTask')"
              color="success"
              :disabled="taskD.type == 'NCLEX' ? !enough : taskD.percentEasy ? (possibleQuestions(true) < numQuestions(true) || possibleQuestions(false) < numQuestions(false)) : (possibleQuestions() < taskD.numOfQuestions)"
              depressed
            >{{popup.type == 'Creating Task' ? 'Create' : 'Update'}}</v-btn>
          </div>
          <div v-else>
            <v-btn
              @click.native="broadcast(popup.type == 'Creating Task' ? 'createTask' : 'updateTask')"
              color="success"
              depressed
            >{{popup.type == 'Creating Task' ? 'Create' : 'Update'}}</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Deleting Task'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">Deleting <b>{{deletingD.name}}</b></div>
          <div class="subheading pb-2">This action cannot be reversed!</div>
          <div class="subheading pb-2">Continue?</div>
          <div>
            <v-btn @click.native="broadcast('delete')" color="error" depressed><b>Delete</b></v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import {contentEvent} from '../../main'
export default {
  props: ['popup', 'taskData', 'deletingData'],
  data: () => ({
    areas: [],
    totals: {},
    enough: true
  }),
  computed: {
    taskD () {
      return this.taskData ? this.taskData : {}
    },
    deletingD () {
      return this.deletingData ? this.deletingData : {}
    },
    possibleQuestions () {
      return (easy) => {
        const questions = this.$store.getters.questions
        if (this.taskD.type === 'Practice') {
          let possibleEasy = 0
          let possibleHard = 0
          for (let i = 0; i < questions.length; i++) {
            let tagsFound = true
            for (let j = 0; j < this.taskD.tags.length; j++) {
              if (!questions[i].tags.includes(this.taskD.tags[j])) tagsFound = false
            }
            if (tagsFound) {
              if (questions[i].tags.includes('Easy')) possibleEasy++
              else possibleHard++
            }
          }
          if (this.taskD.percentEasy) {
            if (easy) return possibleEasy
            else return possibleHard
          } else return possibleEasy + possibleHard
        } else return 0
      }
    },
    numQuestions () {
      return (easy) => {
        if (this.taskD.percentEasy) {
          if (easy) return Math.round(this.taskD.numOfQuestions * (this.taskD.percentEasy / 100))
          else return this.taskD.numOfQuestions - this.numQuestions(true)
        } else return 'random'
      }
    }
  },
  beforeMount () {
    contentEvent.$on('nclexPopup', () => {
      this.nclexQuestions()
    })
  },
  methods: {
    broadcast (event) {
      contentEvent.$emit(event)
      this.popup.show = false
    },
    nclexQuestions () {
      const questions = this.$store.getters.questions
      if (this.taskD.type === 'NCLEX') {
        this.areas = []
        this.totals = {}
        this.enough = true
        for (let i = 0; i < questions.length; i++) {
          if (questions[i].area && questions[i].tags.includes(this.taskD.tags)) {
            for (let j = 0; j < questions[i].area.length; j++) {
              if (!this.areas.includes(questions[i].area[j])) {
                this.areas.push(questions[i].area[j])
                this.totals[questions[i].area[j]] = 1
              } else this.totals[questions[i].area[j]]++
            }
          }
        }
        for (let i = 0; i < this.areas.length; i++) {
          if (this.totals[this.areas[i]] < parseInt(this.taskD.maxQuestions)) this.enough = false
        }
      } else return 0
    },
    linkedTaskPath () {
      let path = ''
      if (this.taskD.linkedTaskKey) {
        let linkedTask = this.$store.getters.taskByKey(this.taskD.linkedTaskKey)
        let section = this.$store.getters.sectionByKey(linkedTask.sectionKey)
        let content = this.$store.getters.contentByKey(section.contentKey)
        path = content.name + ' / ' + section.name + ' / ' + linkedTask.name
      }
      return path
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/TaskPopup.vue